import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { EmpresaQueVendeComCartoes } from '../../pkw-data/collect/empresa-que-vende-com-cartoes.model'
import { Agente } from '../../pkw-data/collect/estabelecimento/agente.model'
import { Estabelecimento } from '../../pkw-data/collect/estabelecimento/estabelecimento.model'
import { Situacao } from '../../pkw-data/collect/estabelecimento/situacao.enum'
import { ListaPaginada, Pagina } from '../../pkw-data/core/util/lista-paginada.model'
import { PkwDatastore } from '../../pkw-data/pkw-datastore'
import { environment } from '../../../environments/environment'

@Injectable()
export class EstabelecimentoService {
    constructor(private pkwDatastore: PkwDatastore) {}

    novo() {
        const estabelecimento = this.pkwDatastore.createRecord(Estabelecimento)

        estabelecimento.agente = this.pkwDatastore.createRecord(Agente)
        estabelecimento.empresa = this.pkwDatastore.createRecord(
            EmpresaQueVendeComCartoes
        )

        return estabelecimento
    }

    obter(id: string) {
        return this.pkwDatastore.findRecord(Estabelecimento, id, {
            include: 'agente,empresa,agente.operadoraDeMaquina,empresa.empresa',
            'fields[agentes]': 'usuario,operadoraDeMaquina',
            'fields[empresas-que-vendem-com-cartoes]': 'empresa',
            'fields[empresas]': 'idExterno,nome',
            'fields[operadoras-de-maquina]': 'nome'
        })
    }

    pesquisar(filtro: any, indicePagina?: number, tamanhoPagina?: number) {
        const pagina = new Pagina(indicePagina, tamanhoPagina)

        return this.pesquisarPaginado(filtro, pagina)
    }

    pesquisarPaginado(filtro: any, pagina: Pagina) {
        const params = {
            filter: filtro,
            page: pagina.toLimitOffset(),
            include: 'agente,empresa,agente.operadoraDeMaquina,empresa.empresa',
            sort: 'empresa.empresa.idExterno',
            'fields[agentes]': 'operadoraDeMaquina',
            'fields[empresas-que-vendem-com-cartoes]': 'empresa',
            'fields[empresas]': 'idExterno,nome',
            'fields[operadoras-de-maquina]': 'nome'
        }

        return this.pkwDatastore
            .findAll(Estabelecimento, params)
            .map(
                response =>
                    new ListaPaginada<Estabelecimento>(
                        response.getModels(),
                        pagina.indice,
                        pagina.tamanho,
                        response.getMeta().meta.totalResourceCount
                    )
            )
    }

    montarCustomUrl(queryString: string): string {
        const baseURL = environment.collectJsonApiBaseUrl;
        const endpoint = 'estabelecimentos'; //this.estabelecimento.modelConfig.type;

        return `${baseURL}/${endpoint}?${queryString}`;
    }

    pesquisarPorQuery(queryString: string, pagina: Pagina) {
        const page = pagina.toLimitOffset();
        const queryPagina = `&page[limit]=${page.limit}&page[offset]=${page.offset}`;
        const customUrl = this.montarCustomUrl(queryString+queryPagina);

        return this.pkwDatastore
            .findAll(Estabelecimento, undefined, undefined, customUrl)
            .map(
                response =>
                    new ListaPaginada<Estabelecimento>(
                        response.getModels(),
                        pagina.indice,
                        pagina.tamanho,
                        response.getMeta().meta.totalResourceCount
                    )
            )
    }

    adquirirTotalResourceCount(queryString: string) {
        const customUrl = this.montarCustomUrl(queryString);

        return this.pkwDatastore
            .findAll(Estabelecimento, undefined, undefined, customUrl)
            .map(
                response => {
                    return response.getMeta().meta.totalResourceCount
                }
            )
    }

    salvar(estabelecimento: Estabelecimento) {
        if (estabelecimento.id) {
            if (estabelecimento.situacao === Situacao.VerificarSenha) {
                estabelecimento.situacao = Situacao.Ativo
            }

            return Observable.forkJoin(
                estabelecimento.agente.save(),
                estabelecimento.save()
            ).map(([agenteSalvo, estabelecimentoSalvo]) => estabelecimentoSalvo)
        } else {
            const agente$ = estabelecimento.agente.save()
            const empresaQVCC$ = this.pkwDatastore
                .findAll(EmpresaQueVendeComCartoes, {
                    'filter[empresa][id]': estabelecimento.empresa.empresa.id
                })
                .map(response => response.getModels().shift())
                .concatMap(empresaQVCC => {
                    if (empresaQVCC) {
                        return Observable.of(empresaQVCC)
                    }

                    return estabelecimento.empresa.save()
                })

            return Observable.forkJoin(agente$, empresaQVCC$).concatMap(
                ([agente, empresa]) => {
                    estabelecimento.agente = agente
                    estabelecimento.empresa = empresa

                    return estabelecimento.save()
                }
            )
        }
    }

    excluir(estabelecimento: Estabelecimento) {
        return this.pkwDatastore.deleteRecord(Estabelecimento, estabelecimento.id)
    }

    obterTotalDeCarentes(): Observable<number> {
        const filter = {
            carente: true
        }

        return this.pkwDatastore
            .findAll(Estabelecimento, { filter })
            .map(response => response.getMeta().meta.totalResourceCount)
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/shared/estabelecimento.service.ts